// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  width: 100%;
  grid-area: header;
  padding-top: 1%;
  background-color: var(--color-middle);
}

.header-buttons {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 3%;
}

/* .header-buttons> button:nth-child(3) {
     margin-left: 10%;

} */

.dropdown-menu {
  margin-left: 10%;
  display: flex;
  gap: 3%;
}

.header-button {
  border: 1px solid var(--color-darker);
  border-radius: 25% 25% 0 0;
  /* border-bottom-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem; */
  background-color: var(--color-darker);
  color: var(--color-light);
  transition: background-color 0.3s;
}


.header-button-active {
  border: 1px solid var(--color-light);
  border-radius: 25% 25% 0 0;
  /* border-bottom-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem; */
  background-color: var(--color-light);
  color: var(--color-darker);
}

.header-button:hover {
  background-color: var(--color-light);
  color: var(--color-darkest);
  border: 1px solid var(--color-light);
  cursor: pointer;
}

.icon {
  display: none;
}

@media screen and (max-width: 660px) {
  .icon {
    display: block;
    float: right;
    color: var(--color-darkest);
    align-self: center;
    font-size: 1.8rem;
    margin-left: 10%;
  }

  .dropdown-menu {
    display: none;
    width: 100%;
    clear: both;
  }

  .dropdown-menu.active {
    display: flex;
    margin-top: 1%;
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/static/css/header.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,OAAO;AACT;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B;0CACwC;EACxC,qCAAqC;EACrC,yBAAyB;EACzB,iCAAiC;AACnC;;;AAGA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B;0CACwC;EACxC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,WAAW;EACb;;EAEA;IACE,aAAa;IACb,cAAc;IACd,2BAA2B;EAC7B;AACF","sourcesContent":["header {\n  width: 100%;\n  grid-area: header;\n  padding-top: 1%;\n  background-color: var(--color-middle);\n}\n\n.header-buttons {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 3%;\n}\n\n/* .header-buttons> button:nth-child(3) {\n     margin-left: 10%;\n\n} */\n\n.dropdown-menu {\n  margin-left: 10%;\n  display: flex;\n  gap: 3%;\n}\n\n.header-button {\n  border: 1px solid var(--color-darker);\n  border-radius: 25% 25% 0 0;\n  /* border-bottom-left-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem; */\n  background-color: var(--color-darker);\n  color: var(--color-light);\n  transition: background-color 0.3s;\n}\n\n\n.header-button-active {\n  border: 1px solid var(--color-light);\n  border-radius: 25% 25% 0 0;\n  /* border-bottom-left-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem; */\n  background-color: var(--color-light);\n  color: var(--color-darker);\n}\n\n.header-button:hover {\n  background-color: var(--color-light);\n  color: var(--color-darkest);\n  border: 1px solid var(--color-light);\n  cursor: pointer;\n}\n\n.icon {\n  display: none;\n}\n\n@media screen and (max-width: 660px) {\n  .icon {\n    display: block;\n    float: right;\n    color: var(--color-darkest);\n    align-self: center;\n    font-size: 1.8rem;\n    margin-left: 10%;\n  }\n\n  .dropdown-menu {\n    display: none;\n    width: 100%;\n    clear: both;\n  }\n\n  .dropdown-menu.active {\n    display: flex;\n    margin-top: 1%;\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
